import Cookies from "js-cookie";

export const saveThemeCookie = (isDark: boolean) => {
  Cookies.set("theme", isDark ? "Dark" : "Light", {
    expires: 365,
    sameSite: "Lax",
  });
};
